import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formControl: {
    minWidth: 100,
  },
  errorMessage: {
    fontSize: theme.typography.helper.fontSize,
    marginTop: theme.spacing(1),
  },
});

const DateDropdownGroup = ({ classes, label, onChange, isValid, required }) => {
  const [yearValue, setYearValue] = useState("");
  const [monthValue, setMonthValue] = useState("");
  const [dayValue, setDayValue] = useState("");

  const padZero = (value, digits) =>
    ("0".repeat(digits - 1) + value.toString()).slice(-digits);

  const months = Array.from({ length: 12 }, (item, i) => [
    new Date(0, i).toLocaleString("en-US", { month: "long" }),
    i + 1,
  ]);

  const days = Array.from({ length: 31 }, (item, i) => i + 1);

  const generateYearOptions = () => {
    const options = [];
    const startYear = 1900;
    const endYear = new Date().getFullYear();
    for (let i = endYear; i >= startYear; i--) {
      options.push(i);
    }
    return options;
  };

  const dateString = useMemo(() => {
    if (!yearValue || !monthValue || !dayValue) return;
    return `${yearValue}-${padZero(monthValue, 2)}-${padZero(dayValue, 2)}`;
  }, [yearValue, monthValue, dayValue]);

  useEffect(() => {
    if (!dateString) return;
    onChange(dateString);
  }, [dateString]);

  return (
    <FormControl
      className={classes.root}
      error={!isValid}
      {...(required && { required })}
      {...(label && { style: { paddingTop: 16 } })}
    >
      {label && (
        <InputLabel id="birthdate-label" shrink>
          {label}
        </InputLabel>
      )}
      <Grid container spacing={1}>
        <Grid item>
          <FormControl error={!isValid} className={classes.formControl}>
            <InputLabel id="month-dropdown-label">Month</InputLabel>
            <Select
              labelId="month-dropdown-label"
              id="month-dropdown"
              defaultValue=""
              onChange={(e) => setMonthValue(e.target.value)}
              inputProps={{ name: "month" }}
            >
              {months.map(([l, v], k) => (
                <MenuItem key={k} value={v}>
                  {l}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl error={!isValid} className={classes.formControl}>
            <InputLabel id="day-dropdown-label">Date</InputLabel>
            <Select
              labelId="day-dropdown-label"
              id="day-dropdown"
              defaultValue=""
              onChange={(e) => setDayValue(e.target.value)}
              inputProps={{ name: "day" }}
            >
              {days.map((v, k) => (
                <MenuItem key={k} value={v}>
                  {v}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl error={!isValid} className={classes.formControl}>
            <InputLabel id="year-dropdown-label">Year</InputLabel>
            <Select
              labelId="year-dropdown-label"
              id="year-dropdown"
              defaultValue=""
              onChange={(e) => setYearValue(e.target.value)}
              inputProps={{ name: "year" }}
            >
              {generateYearOptions().map((v, k) => (
                <MenuItem key={k} value={v}>
                  {v}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      {!isValid && (
        <Typography color="error" className={classes.errorMessage}>
          Invalid Date
        </Typography>
      )}
    </FormControl>
  );
};

DateDropdownGroup.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  required: PropTypes.bool,
};

export default withStyles(styles)(DateDropdownGroup);



// WEBPACK FOOTER //
// ./src/components/Forms/DateDropdownGroup.jsx